import React, {
  ChangeEvent,
  createContext,
  ReactNode,
  useMemo,
  useState,
} from "react";
import { IntlProvider } from "react-intl";

import EnglishTranslation from "@app/lang/en.json";
import FrenchTranslation from "@app/lang/fr.json";

interface LanguageContextProps {
  locale: string;
  selectLanguage: (e: ChangeEvent<HTMLSelectElement>) => void;
}

export const LanguageContext = createContext<LanguageContextProps | undefined>({
  locale: "en",
  selectLanguage: () => {
    return;
  },
});

interface LanguageWrapperProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageWrapperProps> = ({
  children,
}) => {
  const [locale, setLocale] = useState<string>(() => {
    return localStorage.getItem("locale") ?? "en";
  });

  const [messages, setMessages] = useState(
    locale === "fr" ? FrenchTranslation : EnglishTranslation,
  );

  const selectLanguage = (e: ChangeEvent<HTMLSelectElement>) => {
    const newLocale = e.target.value;
    setLocale(newLocale);
    setMessages(newLocale === "fr" ? FrenchTranslation : EnglishTranslation);
    localStorage.setItem("locale", newLocale);
  };

  const languageProviderValue = useMemo(
    () => ({ locale, selectLanguage }),
    [locale],
  );

  return (
    <LanguageContext.Provider value={languageProviderValue}>
      <IntlProvider messages={messages} locale={locale}>
        {children}
      </IntlProvider>
    </LanguageContext.Provider>
  );
};
